import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';

import { Auth, CommonService } from './services';
import { SidebarComponent } from './pages/sidebar/sidebar.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    CommonModule,
    SidebarComponent,
    MatProgressSpinnerModule
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('zignflix-admin');

  constructor(public auth: Auth, private commonService: CommonService) { }

  get showSpinner() {
    return this.commonService.showSpinner;
  }
}
